import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApiInstructionComponent } from './pages/api-instruction/api-instruction.component';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';

const routes: Routes = [
  {
    path: '',
    component: ApiInstructionComponent,
    data: { title: routeMetaData.accessAndUse.title },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApiInstructuionRoutingModule {}
